export default "__VITE_ASSET__CWOTPJxD__"